import { ConversationFilterIds, ScreeningStatusFilter } from './enums';
import { getConversationFilterLabel } from '../utils/getConversationFilterLabel';

export const screeningStatusFilterOptions = [
  {
    value: ScreeningStatusFilter.PROGRESSED,
    label: getConversationFilterLabel(
      ConversationFilterIds.screeningStatus,
      ScreeningStatusFilter.PROGRESSED
    )
  },
  {
    value: ScreeningStatusFilter.REJECTED,
    label: getConversationFilterLabel(
      ConversationFilterIds.screeningStatus,
      ScreeningStatusFilter.REJECTED
    )
  },
  {
    value: ScreeningStatusFilter.NOT_INTERESTED,
    label: getConversationFilterLabel(
      ConversationFilterIds.screeningStatus,
      ScreeningStatusFilter.NOT_INTERESTED
    )
  },
  {
    value: ScreeningStatusFilter.INCOMPLETE,
    label: getConversationFilterLabel(
      ConversationFilterIds.screeningStatus,
      ScreeningStatusFilter.INCOMPLETE
    )
  },
  {
    value: ScreeningStatusFilter.OPTED_OUT,
    label: getConversationFilterLabel(
      ConversationFilterIds.screeningStatus,
      ScreeningStatusFilter.OPTED_OUT
    )
  }
];
